export const menuData = [
    { title: 'Αρχική', link: '/' },
    { title: 'Προϊόντα', link: '/#prods' },
    { title: 'Επικοινωνία', link: '/about' },   
]